import { Component, OnInit, output } from '@angular/core';
import { getFileExtension } from '../../helpers/file.helper';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-whitelabel-ios-certificate-upload',
  templateUrl: './whitelabel-ios-certificate-upload.component.html',
  styleUrls: ['./whitelabel-ios-certificate-upload.component.css']
})
export class WhitelabelIosCertificateUploadComponent implements OnInit {

  public readonly errorEvent$ = output<void>();

  public readonly successEvent$ = output<File>();

  ngOnInit(): void {
  }

  public onCertificateUpload(event: any) {
    const files = event.target.files as FileList;
    const uploadedFile = files[0];
    
    if (uploadedFile) {
      const fileExtension = getFileExtension(uploadedFile.name);
  
      if (fileExtension !== '.p12') {
        this.errorEvent$.emit();
        return;
      }
      
      this.successEvent$.emit(uploadedFile);
    }

    return;
  }

}
